export const LEGAL_VERSION = "2026-07-23";
